const config = {
  rootProjectId: "root",
  uiBucketName: "starbuckskz.c.retter.io",
  appUrl: "https://api.starbuckskz.retter.io/",
  cosUrl: "api.starbuckskz.retter.io",
  version: "2.1.13",
  captchaKey: "6LdbUxUqAAAAANfTNpXchJB9EOap2dW6PL_hB7gv",
  stage: "PROD"
}
export default config

